import React from 'react';

import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

export enum ChangeStudyableAssignmentPermissionOriginType {
  /* When selecting a study */
  STUDY = 'STUDY',
  /* When selecting a folder for the study */
  FOLDER = 'FOLDER',
}

interface ChangeStudyableAssignmentPermissionWarningBanner {
  invalidStudyNames?: Array<string>;
  warningOriginType: ChangeStudyableAssignmentPermissionOriginType;
}

export default function ChangeStudyableAssignmentPermissionWarningBanner({
  warningOriginType,
  invalidStudyNames,
}: ChangeStudyableAssignmentPermissionWarningBanner): JSX.Element {
  const invalidStudyNamesText =
    (invalidStudyNames ?? []).length > 0 ? `: ${invalidStudyNames?.join(', ')}` : '';
  const text =
    warningOriginType === ChangeStudyableAssignmentPermissionOriginType.STUDY
      ? `You don't have permission to link items to the following studies${invalidStudyNamesText}.`
      : "You don't have permission in this folder to link items to studies.";
  const supportingInfo = 'Contact your administrator for study access in this folder.';
  return <InlineBanner bannerType={InlineBannerType.ERROR} text={text} supportingInfo={supportingInfo} />;
}
